import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../firebase";
import { doc, onSnapshot } from "firebase/firestore";
import { FaBell } from "react-icons/fa";
import "./NotificationBell.css";

const NotificationBellSeniorGET = () => {
  const [pendingReviewNotification, setPendingReviewNotification] = useState(null);
  const [open, setOpen] = useState(false);
  const [seniorId, setSeniorId] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    // Asumimos que el senior GET tiene un ID fijo "senior_get"
    // Si el senior se identifica dinámicamente, ajusta esta lógica
    const seniorIdentifier = "senior_get"; // Ajusta según cómo identificas al senior en el sistema
    setSeniorId(seniorIdentifier);

    if (!seniorIdentifier) {
      return;
    }

    // Escuchar notificaciones de actividades pendientes de revisión
    const pendingReviewSummaryRef = doc(db, `notifications/${seniorIdentifier}/pending_reviews/status`);
    const unsubPendingReview = onSnapshot(
      pendingReviewSummaryRef,
      (docSnapshot) => {
        if (docSnapshot.exists()) {
          const data = { id: docSnapshot.id, ...docSnapshot.data() };
          console.log("Notificación de revisiones recibida para senior GET:", data);
          setPendingReviewNotification(data);
        } else {
          console.log("No hay notificación de revisiones activa para el senior GET");
          setPendingReviewNotification(null);
        }
      },
      (error) => {
        console.error("Error al escuchar notificación de revisiones:", error);
      }
    );

    return () => unsubPendingReview();
  }, []);

  const handleGoToPendingReviews = () => {
    navigate("/RevisarActividadesSeniorGET"); // Ajusta la ruta según corresponda
    setOpen(false);
  };

  if (!seniorId) {
    return <div className="text-sm text-gray-600">Por favor, inicia sesión para ver notificaciones.</div>;
  }

  return (
    <div className="notification-bell-container">
      <div
        className="bell-icon"
        onClick={() => setOpen((prev) => !prev)}
      >
        <FaBell size={24} />
        {pendingReviewNotification && (
          <span className="notification-count">{pendingReviewNotification.count}</span>
        )}
      </div>

      {open && (
        <div className="notification-dropdown">
          {pendingReviewNotification ? (
            <div className="notification-item">
              <p>{pendingReviewNotification.message}</p>
              <button onClick={handleGoToPendingReviews}>Ir</button>
            </div>
          ) : (
            <p className="text-sm text-gray-600 p-4 text-center">
              No hay nuevas notificaciones
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default NotificationBellSeniorGET;